import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { Grid } from "@mui/material";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import ContributionPlanPicker from "../../pickers/ContributionPlanPicker";
import InsureePicker from "../../pickers/InsureePicker";
import { useDispatch, useSelector } from "react-redux";
import DatePickers from "../../pickers/DatePicker";
import { updatePolicyHolderInsuree } from "../../action";
import CalendarPicker from "../../pickers/CalenderPicker";
import { formatDateFromISO } from "../../utils/helper";

const UpdateInsureesDialog = ({
  setShowUpdateDialog,
  showUpdateDialog,
  currentUser,
  rowData,
  setSnackbarMessage,
}) => {
  const dispatch = useDispatch();
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const [insureeData, setInsureeData] = useState();

  useEffect(() => {
    setInsureeData(SignInSuccess?.profileReducer?.insureeByIdResponseData);
  }, [SignInSuccess]);
  const handleClose = () => {
    setShowUpdateDialog(false);
  };
  const validate = (values) => {
    const errors = {};
    if (!values.insureeNo) {
        errors.insureeNo = t("Field is required");
    }
    if (!values.contributionPlan) {
        errors.contributionPlan = t("Field is required");
    }
    if (!values.income) {
        errors.income = t("Field is required");
    }
    if (!values.validFrom) {
        errors.validFrom = t("Field is required");
    }
    return errors;
};
  const onSubmit = async (values) => {
    const data = insureeData;
    const value = { values, ...data };
    setSnackbarMessage(t("PolicyHolder Insuree Updated Sucessfully"));
    dispatch(updatePolicyHolderInsuree(value, currentUser?.id, rowData?.id));
    console.log("values", value);
  };
  return (
    <React.Fragment>
      <Dialog open={showUpdateDialog}>
        <DialogTitle>{t("Update Policy Holder Insuree")}</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item>
              <Grid container>
                <Form
                  onSubmit={onSubmit}
                  validate={validate}
                  initialValues={{
                    insureeNo: rowData?.insuree?.chfId,
                    contributionPlan: rowData?.contributionPlanBundle?.id,
                    employeeNo: rowData?.employerNumber || "",
                    income: rowData?.jsonExt
                      ? JSON.parse(rowData.jsonExt).calculation_rule?.income
                      : "",
                    // validFrom: rowData?.dateValidFrom || "",
                    validFrom: rowData?.dateValidFrom
                      ? rowData.dateValidFrom.split("T")[0]
                      : "",
                    validTo: rowData?.dateValidTo
                      ? rowData.dateValidTo.split("T")[0]
                      : "",
                  }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                    errors,
                  }) => (
                    // setFormValues(values),
                    <form onSubmit={handleSubmit}>
                      <Grid container>
                        <Grid item xs={12} className="common-input">
                          <Field
                            name="insureeNo"
                            component={InsureePicker}
                            label={t("Temporary CAMU No./CAMU No.")}
                            required
                            type="text"
                            insureeNo={values}
                                                        disabled={true}
                          />
                        </Grid>
                        <Grid item xs={6} className="common-input">
                          <Field
                            name="contributionPlan"
                            component={ContributionPlanPicker}
                            label={t("Contribution Plan Bundle")}
                            currentUser={currentUser}
                                                        disabled={true}

                            // type="text"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          className="common-input"
                          style={{ marginTop: "2px" }}
                        >
                          <Field
                            name="employeeNo"
                            component={TextInput}
                            label={t("Employee No.")}
                            required
                            type="text"
                          />
                        </Grid>
                        <Grid item xs={6} className="common-input">
                          <Field
                            name="income"
                            component={TextInput}
                            label="Income"
                            type="text"
                          />
                        </Grid>
                        <Grid item xs={6} className="common-input">
                          <Field
                            name="validFrom"
                            component={CalendarPicker}
                            label={t("Created From")}
                            onChange={(value) =>
                              form.change("validFrom", value)
                            }
                            inputVal={formatDateFromISO(values.validFrom)}
                            row={rowData}
                                                        disabled={true}
                                        
                          />
                        </Grid>
                        <Grid item xs={6} className="common-input">
                          <Field
                            name="validTo"
                            component={CalendarPicker}
                            inputVal={formatDateFromISO(values.validTo)}
                            label={t("Date Valid To")}
                            onChange={(value) => form.change("validTo", value)}
                          />
                        </Grid>
                      </Grid>
                      <DialogActions>
                        <Button onClick={handleClose}>{t("cancel")}</Button>

                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          disabled={submitting || pristine || Object.keys(errors).length > 0}
                          // style={{ width: "100%" }}
                          // fullWidth
                        >
                          {t("Update")}
                        </Button>
                      </DialogActions>
                    </form>
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
export default UpdateInsureesDialog;
